const NotFound = () => {
  return (
    <div>
      <h1 className='text-2xl'>404: Not Found</h1>
    </div>
  )
}

export default NotFound
